import { render, staticRenderFns } from "./activity-feed.vue?vue&type=template&id=f83bca42&scoped=true&"
import script from "./activity-feed.vue?vue&type=script&lang=ts&"
export * from "./activity-feed.vue?vue&type=script&lang=ts&"
import style0 from "./activity-feed.vue?vue&type=style&index=0&id=f83bca42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83bca42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VCard,VCardTitle,VTimeline,VVirtualScroll})
